import { render, staticRenderFns } from "./SearchBoxCore.vue?vue&type=template&id=539e31a1&scoped=true"
import script from "./SearchBoxCore.vue?vue&type=script&lang=js"
export * from "./SearchBoxCore.vue?vue&type=script&lang=js"
import style0 from "./SearchBoxCore.vue?vue&type=style&index=0&id=539e31a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e31a1",
  null
  
)

export default component.exports